<div style="width: auto; overflow: auto">
    <app-common-list-table [request]="getRequest" [cols]="cols" [filtering]="filter"
        [actionButtonText]="canAddFincas ? 'Añadir ' + fincaName : ''" (actionButtonClick)="add()"
        [globalConditionalStyle]="globalConditionalStyle" [globalVisualTransform]="globalVisualTransform"
        [customExportCsv]="showFincasCsv" (visualize)="show('info', $event)" (edit)="edit($event)"
        (remove)="show('delete', $event)">

        <ng-template #header>
            <div style="margin-left: 20px;">
                <button class="mx-2 btn" (click)="downloadCsv()"
                    style="padding: 5px; font-size: .8rem; background-color: #16A2B7; color: white">
                    <i class="fa fa-download"></i>
                    Exportar listado
                </button>
            </div>
        </ng-template>
        <ng-template #thEnd>
            <th *ngIf="showCuadernoDeCampo">
                <p class="d-flex justify-content-center" style="margin-bottom: 0">
                    {{appName === 'donjardin' ? 'Registro Transacciones' : 'Cuaderno'}}
                </p>
            </th>
            <th>
                <p class="d-flex justify-content-center" style="margin-bottom: 0">Acciones</p>
            </th>
            <th *ngIf="showCargaPAC">
                <p class="d-flex justify-content-center" style="margin-bottom: 0">PAC</p>
            </th>
            <th *ngIf="showFincasGenGml">
                <p class="d-flex justify-content-center" style="margin-bottom: 0">GML</p>
            </th>
            <th *ngIf="activateREA">
                <p class="d-flex justify-content-center" style="margin-bottom: 0">REA</p>
            </th>
            <th *ngIf="activateREA">
                <p class="d-flex justify-content-center" style="margin-bottom: 0">CUE</p>
            </th>
        </ng-template>

        <ng-template #tdEnd let-data>
            <td *ngIf="showCuadernoDeCampo">
                <div class="d-flex justify-content-center">
                    <div class="justify-content-center">
                        <button (click)="show('generate', data); filterSectores()"
                            class="d-flex justify-content-center align-items-center" style="
                            height: 20px;
                            width: 85px;
                            border: none;
                            border-radius: 3px;
                            background-color: #345fdc;
                            color: white;
                            cursor: pointer;">
                            <i class="fa fa-book"></i>
                            <span>&nbsp;Generar</span>
                        </button>
                    </div>
                </div>
            </td>
            <td>
                <app-action-buttons [hideEdit]="!canEditFincas" [hideDelete]="!canDeleteFincas"
                    [showDuplicate]="canDuplicateFinca" (duplicateRowButtonEvent)="duplicate(data.data)"
                    (editRowButtonEvent)="edit(data.data)" (deleteRowButtonEvent)="show('delete', data.data)"
                    (showRowButtonEvent)="show('info', data.data)">
                </app-action-buttons>
            </td>
            <td *ngIf="showCargaPAC">
                <div class="d-flex justify-content-center">
                    <div class="justify-content-center">
                        <button class="d-flex justify-content-center align-items-center"
                            (click)="uploadDialog(data.data)" style="
                            height: 20px;
                            width: 45px;
                            border-radius: 3px;
                            border: none;
                            background-color: #28a645;
                            color: white">
                            <i class="fa fa-upload"></i>
                        </button>
                    </div>
                </div>

            </td>
            <td *ngIf="showFincasGenGml">
                <div class="d-flex justify-content-center">
                    <div class="justify-content-center">
                        <button class="d-flex justify-content-center align-items-center" (click)="generaGML(data.data)"
                            style="
                            height: 20px;
                            width: 45px;
                            border-radius: 3px;
                            border: none;
                            background-color: #2863a6;
                            color: white">
                            <i class="fa fa-download"></i>
                        </button>
                    </div>
                </div>

            </td>
            <td *ngIf="activateREA">
                <div class="d-flex justify-content-center">
                    <div class="justify-content-center">
                        <button class="d-flex justify-content-center align-items-center"
                            (click)="show('importREA', data.data)" style="
                            height: 20px;
                            width: 45px;
                            border-radius: 3px;
                            border: none;
                            background-color: #a67e28;
                            color: white">
                            <i class="fa fa-download"></i>
                        </button>
                    </div>
                </div>
            </td>
            <td *ngIf="activateREA">
                <div class="d-flex justify-content-center">
                    <div class="justify-content-center">
                        <button [pTooltip]="tooltipContent" class="d-flex justify-content-center align-items-center"
                            (click)="show('sendCUE', data.data)" style="
                            height: 20px;
                            width: 45px;
                            border-radius: 3px;
                            border: none;
                            background-color: #a23001;
                            color: white">

                            @if(data.data.estado_cue === 'completo'){
                                <i class="fa fa-upload"></i>
                            }
                            @else if (data.data.estado_cue === 'en_proceso'){
                                <i class="fa fa-spinner fa-spin"></i>
                            }
                            @else if (data.data.estado_cue === 'no_proceso'){
                                <i class="fa fa-times"></i>
                            }
                            @else{
                                <i class="fa fa-upload"></i>
                            }
                        </button>
                            <ng-template #tooltipContent>
                                <div class="d-flex flex-column">
                                    <p>Estado del CUE</p>
                                    <p *ngIf="data.data.estado_cue === 'completo'">
                                        <i class="fa fa-check-circle"></i> Completo
                                    </p>
                                    <p *ngIf="data.data.estado_cue === 'en_proceso'">
                                        <i class="fa fa-spinner fa-spin"></i> En proceso
                                    </p>
                                    <p *ngIf="data.data.estado_cue === 'no_proceso'">
                                        <i class="fa fa-times"></i> No proceso
                                    </p>
                                </div>
                            </ng-template>
                    </div>
                </div>
            </td>
        </ng-template>
    </app-common-list-table>
</div>

<p-dialog *ngIf="canShow['generate']" header="Generar Word" [(visible)]="canShow['generate']" (onShow)="scrollToTop()">

    <div [ngStyle]="{'width.vw': '50'}" style="min-height: 40vw !important; ">
        <app-form-builder [model]="model" [fields]="generarFields" [distributionColumns]="2"
            (formChanges)="formChanges()">
        </app-form-builder>
        <div *ngIf="parcelasAux && sectores.selected">
            <br>
            <p style="text-align: center; color: red">Este sector no tiene parcelas</p>
        </div>
        <br>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="hide('generate')">Cerrar</button>

            <button *ngIf="appName !== 'donjardin'" class="d-flex justify-content-center mx-2 btn btn-primary"
                (click)="generarCuaderno();">Generar Word</button>


            <button *ngIf="showFincasInformeTratamientos || (user?.nombre === 'ALEJANDRO' && appName === 'melia')"
                class="d-flex justify-content-center mx-3" (click)="generarCuaderno(true, false);">
                <button class="btn btn-secondary">{{showTareasMto ? 'Generar' : 'Informe Tratamientos'}}</button>
            </button>

            <button *ngIf="showFincasLibroFertilizantes" class="d-flex justify-content-center mx-3"
                (click)="generarCuaderno(false, true);">
                <button class="btn btn-secondary">Generar Libro Fertilizantes</button>
            </button>
            <button [hidden]="true" class="btn ms-5" style="background-color: green; color: white">Enviar a
                SIEX</button>
        </div>
        <br>
    </div>
</p-dialog>

<p-dialog *ngIf="canShow['info']" header="Detalle del registro" [(visible)]="canShow['info']" (onShow)="scrollToTop()">

    <div style="width: 80vw !important">
        <h5 *ngIf="this.appName !== 'gardengest'">Datos {{appName === 'gardengest' ? 'del' : 'de la' }} {{ fincaName }}
        </h5>
        <app-form-builder [fields]="formFields" [distributionColumns]="3" [model]="model">
        </app-form-builder>
        <br>
        <h5 *ngIf="this.appName !== 'gardengest'">Datos del titular</h5>
        <app-form-builder *ngIf="this.appName !== 'gardengest'" [fields]="formFieldsTitular" [distributionColumns]="3"
            [model]="model">
        </app-form-builder>
        <br>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="hide('info')">Cerrar</button>
        </div>
    </div>
    <br>
</p-dialog>

<p-dialog *ngIf="canShow['delete']" header="Eliminar registro" [(visible)]="canShow['delete']" (onShow)="scrollToTop()">

    <div style="width: 80vw !important">
        <h5 *ngIf="this.appName !== 'gardengest'">Datos {{appName === 'gardengest' ? 'del' : 'de la' }} {{ fincaName }}
        </h5>
        <app-form-builder [fields]="formFields" [distributionColumns]="3" [model]="model">
        </app-form-builder>
        <br>
        <h5 *ngIf="this.appName !== 'gardengest'">Datos del titular</h5>
        <app-form-builder *ngIf="this.appName !== 'gardengest'" [fields]="formFieldsTitular" [distributionColumns]="3"
            [model]="model">
        </app-form-builder>
        <br>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="hide('delete')">Cerrar</button>
            <app-request-button [warning]="deleteWarning" (click)="deleteRegister()" [request]="deleteRequest"
                [mode]="deleteRequestButtonType">
            </app-request-button>
        </div>
        <br>
        <p *ngIf="deleteRequest.hasError === undefined && !deleteRequest.isLoading && deleteWarning"
            style="color: red; text-align: center">
            {{deleteWarningMessage}}
        </p>
        <p *ngIf="deleteRequest.hasError === undefined && !deleteRequest.isLoading"
            style="color: red; text-align: center">
            ¿Está seguro de eliminar este registro?
        </p>
    </div>
    <br>

</p-dialog>

<p-dialog width="600" header="Importar datos PAC" [closeOnEscape]="false" [closable]="false" [(visible)]="showModalPAC"
    (onShow)="scrollToTop()">

    <div *ngIf="showModalPAC" style="width: 36vw !important">

        <div>
            <p-fileUpload name="myfile[]" [disabled]="!enableUpload" multiple="false" [showCancelButton]="false"
                chooseLabel="Seleccionar archivo" uploadLabel="Enviar" [url]="urlUpload" (onSelect)="checkFile($event)"
                (onUpload)="uploaded($event)">
            </p-fileUpload>
        </div>

        <div *ngIf="showPACError">
            <br>
            <p style="max-width: 400px; text-align: center; color: red" [innerHTML]="txtPACError"></p>
            <p style="max-width: 400px; text-align: center; color: green" [innerHTML]="txtPACInfo"></p>

        </div>
        <br>
        <div class="d-flex justify-content-center">
            <button class="btn btn-dark mx-2" (click)="closeFUDialog();">Cerrar</button>
        </div>
        <br>
    </div>
</p-dialog>


<p-dialog *ngIf="canShow['importREA']" [(visible)]="canShow['importREA']" header="Importar REA"
    [style]="{width: '50vw'}" [modal]="true" [closable]="false" id="export-rea-dialog">
    <ng-template pTemplate="body">

        <div class="p-fluid">
            <div class="p-field p-col-12 p-md-6">
                <label for="input-text">Codigo REA</label> : {{ model.codigo_REA }}
            </div>
            <div class="p-field p-col-12 p-md-6">
                <label for="input-text">NIF</label>: {{ model.nif }}
            </div>
        </div>

        <div class="d-flex flex-column justify-content-center align-content-center mx-5">
            <div>
                <p-message class="mx-5" severity="info" *ngIf="historicoREA?.statusCode == 201">Nueva importacion
                </p-message>
                <p-message class="mx-5" severity="info" *ngIf="historicoREA?.statusCode == 200">Última importación: {{
                    historicoREA?.data.fecha }}</p-message>
            </div>
            <p-progress-spinner *ngIf="showSpinner" styleClass="p-component-overlay m-auto" strokeWidth="6"
                animationDuration="1.5s" />

            <div class="w-100" *ngIf="importResult?.statusCode == 202">
                <p-card>
                    <h4>Detalle de importación</h4>
                    <hr>
                    <p>Parcelas no insertadas: <b> {{ importResult?.data.parcelasNoInsertadas }} </b></p>
                    <p>Parcelas insertadas: <b> {{ importResult?.data.parcelasInsertadas }} </b></p>
                    <p>Parcelas no actualizadas: <b> {{ importResult?.data.parcelasNoActualizadas }} </b></p>
                    <p>Parcelas actualizadas: <b> {{ importResult?.data.parcelasActualizadas }} </b></p>
                </p-card>
            </div>
            <p-message class="mx-5" *ngIf="messageState == 'warning'" severity="warn"> 
                Falta datos para exportar REA
            </p-message>
            <p-message class="mx-5" *ngIf="messageState == 'error'" severity="error">
                {{ importResult?.statusMessage }}
            </p-message>
            <p-message class="mx-5" *ngIf="messageState == 'sucess'" severity="success">
                {{ importResult?.statusMessage }}
            </p-message>
        </div>
    </ng-template>

    <ng-template #footer>
        <div class="d-flex justify-content-center align-content-center gap-5 w-100">
            <button class="btn btn-dark mx-2" *ngIf="importResult?.statusCode"
                (click)="hide('importREA'); showSpinner = false; messageState = ''">Volver</button>
            <button class="btn btn-dark bg-gradient" *ngIf="!importResult?.statusCode"
                (click)="hide('importREA'); showSpinner = false; messageState = ''"> Cancelar </button>
            <button class="btn btn-success bg-gradient"
                (click)="showSpinner = true; exportREA(model)">Continuar</button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog *ngIf="canShow['sendCUE']" [(visible)]="canShow['sendCUE']" header="Exportar CUE"
    [style]="{width: '45vw' ,height: '60vh'}" [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [modal]="true"
    [closable]="true" id="export-cue-dialog">
    <div>
        <p-card>
            <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="d.flex flex-column">
                    <h4>Detalles de la finca</h4>
                    <p class="text-muted">
                        <small>Utlima fecha de generación: </small><br>
                        <span> {{ statusCue?.fecha | date: 'dd/MM/yyyy' }} </span>
                    </p>
                </div>

                @switch(statusCue?.estado) {
                    @case('0'){
                    <span class="text-warning border border-1 border-warning p-2 rounded rounded-4"> Generando CUE </span>
                    }
                    @case('1') {
                    <span class="text-success border border-1 border-success p-2 rounded rounded-4"> Disponible </span>
                    }
                    @case('2') {
                    <span class="text-danger border border-1 border-danger p-2 rounded rounded-4"> No se pudo generar el CUE
                    </span>
                    }
                    @default(){
                    <span class="text-success border border-1 border-success p-2 rounded rounded-4"> Disponible </span>
                    }
                }
            </div>
            <div class="d-flex flex-column justify-between">
                <label for=""> Historial CUE </label>
                <select name="" id="">
                    <option value="">Seleccione una opción</option>
                    <option *ngFor="let item of cueHistory; index as i; trackByFn" value="">{{ item.fecha }}</option>
                    <!-- @for(let item of cueHistory; index as i; trackByFn){
                        <option value="">{{ item.fecha }}</option>
                    } -->
                </select>
            </div>
            <hr>
            <div class="d-flex flex-row justify-content-between g-5 gap-5">
                <div class="w-50">
                    <h4>General</h4>
                    <p class="d-flex gap-2"> <b> Finca: </b> {{ model.nombre }} </p>
                    <p class="d-flex gap-2"> <b> Tipo de explotación: </b> {{ model.tipo_explotacion }} </p>
                    <p class="d-flex gap-2"> <b> Codigo REA: </b> {{ model.codigo_REA }} </p>
                    <p class="d-flex gap-2"> <b> Comunidad autónoma: </b> {{ model.comunidad_autonoma_INE }} </p>
                    <p class="d-flex gap-2"> <b> NIF: </b> {{ model.nif }} </p>
                </div>
                <div class="w-50">
                    <h4>Titular</h4>
                    <p class="d-flex gap-2"> <b> Nombre: </b> {{ model.titular_nombre }} </p>
                    <p class="d-flex gap-2"> <b> Localidad: </b> {{ model.titular_localidad }} </p>
                    <p class="d-flex gap-2"> <b> Provincia: </b> {{ model.titular_provincia }} </p>
                    <p class="d-flex gap-2"> <b> Teléfono: </b> {{ model.titular_telefono }} </p>
                    <p class="d-flex gap-2"> <b> Email: </b> {{ model.titular_email }} </p>
                </div>
            </div>
            <p-progress-spinner *ngIf="showSpinner" styleClass="p-component-overlay m-auto" strokeWidth="6"
                animationDuration="1.5s" />
            <p-panel *ngIf="messageState" [toggleable]="true">
                <ng-template #header>
                    <p *ngIf="messageState=='warning'"
                        [ngStyle]="{'color': messageState == 'warning' ? 'yellow':'black'}">
                        {{importResult?.statusMessage}}</p>
                    <p *ngIf="messageState=='error'" [ngStyle]="{'color': messageState == 'error' ? 'red' : 'black'}">
                        {{importResult?.statusMessage}}</p>
                    <p *ngIf="messageState=='success'"
                        [ngStyle]="{'color': messageState == 'success' ? 'green' : 'black'}">
                        {{importResult?.statusMessage}}</p>
                </ng-template>
                <p>
                    {{importResult?.data[0]?.body}}
                </p>
            </p-panel>
        </p-card>
    </div>

    <ng-template pTemplate="footer">
        <div class="d-flex justify-content-center align-content-center gap-5 w-100">
            <button class="btn btn-dark mx-2" *ngIf="importResult?.statusCode"
                (click)="hide('sendCUE'); showSpinner = false; messageState = ''">Volver</button>
            <button class="btn btn-dark bg-gradient" *ngIf="!importResult?.statusCode"
                (click)="hide('sendCUE'); showSpinner = false; messageState = ''"> Cancelar </button>
            <button class="btn btn-success bg-gradient"
                (click)="showSpinner = true; exportCUE(model)">Continuar</button>
        </div>
    </ng-template>
</p-dialog>